import React, {FC, ReactNode} from 'react';

import {computeIsGlobalNamespace} from '../../../../helpers/models/namespaceHelpers';
import {useAppSelector} from '../../../../helpers/reduxHelpers';
import {getAnalyticsSelectedNamespace} from '../../../../store/panels/analytics/parameters/analyticsPanelParametersSelectors';
import {SetupEmptyState} from './setupEmptyState';

/*
 * Props.
 */

interface NoRuleEmptyStateProps {
  width?: number;
  height?: number;
  title: ReactNode;
  buttonText: ReactNode;
  learnMoreLink: string;
  interactionId?: string;
}

/*
 * Component.
 */

export const NoRuleEmptyState: FC<NoRuleEmptyStateProps> = ({
  width,
  height,
  title,
  buttonText,
  learnMoreLink,
  interactionId,
}) => {
  const namespace = useAppSelector(getAnalyticsSelectedNamespace);

  /**
   * We hide the set up rule button when in the global namespace because CSAT + SLA
   * rules (which are the ones that use this page) dont't make sense in the company context
   * since they both require a team namespace to create a valid rule bundle. In the global
   * namespace only the "Learn More" button will be displayed
   */
  const isSetupRuleVisible = !computeIsGlobalNamespace(namespace);
  const setupLink = isSetupRuleVisible ? `/settings/${namespace}/rules/library` : undefined;

  return (
    <SetupEmptyState
      title={title}
      width={width}
      height={height}
      setupLink={setupLink}
      buttonText={buttonText}
      learnMoreLink={learnMoreLink}
      interactionId={interactionId}
    />
  );
};
